import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { authAxios as axios } from "shared-auth";
import { FETCH_ACCESS_TO_CHECKOUT } from "../services";
import { config } from "../../../../config";
import { CheckoutAccessTypes } from "../types";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";

// SinglePageCheckoutNew and CDCheckout only the last billing that use it, must be removed after grads joining will be ready
export const useCanAccessCheckout = (
  enabled = false,
  redirectOnForbiddenUrl = "/",
  shouldRedirectOnForbidden = true
) => {
  const isSelfServeCancellationEnable = useLaunchDarklyFlags([
    FEATURE_FLAGS.SelfServeCancellation,
  ]);

  const { data, isLoading } = useQuery<
    { data: { checkoutType: CheckoutAccessTypes } } | undefined,
    AxiosError
  >(
    [FETCH_ACCESS_TO_CHECKOUT, enabled],
    async () => {
      try {
        return await axios.get(`${config.billingApiUrl}account/access`);
      } catch (e) {
        if (shouldRedirectOnForbidden)
          window.location.replace(redirectOnForbiddenUrl);
      }
    },
    {
      enabled: enabled && !isSelfServeCancellationEnable,
    }
  );

  return { data, isLoading };
};
